import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import Header from "../../Common/Layout/Header";
import { useAuth } from "../../Common/Configurations/AuthContext";
import Modal from "react-bootstrap/Modal";
import { Link } from "react-router-dom";
import DeleteAlert from "../../Common/Layout/DeleteAlert";
import countries from "../../Data/Countries.json";
import currencies from "../../Data/Currency.json";
import AgentTabs from "../AllTabs/AgentTabs";
const initialFieldValues = {
  companyId: "00000000-0000-0000-0000-000000000000",
  companyName: "",
  brandName: "",
  gstNo: "",
  email: "",
  phoneNumber: "",
  logoName: "",
  address: "",
  city: "",
  state: "",
  country: "India",
  currency: "INR",
  companyType: "AGENT",
  parentCompanyId: "00000000-0000-0000-0000-000000000000",
  isActive: true,
};
const AgentCredits = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [btnLoading, setBtnLoading] = useState(false);
  const [lists, setLists] = useState([]);
  const [values, setValues] = useState(initialFieldValues);
  const [errors, setErrors] = useState({});
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [pageNumber, setPageNumber] = useState(1);
  const [data, setData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [addShow, setAddShow] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const handleOpenDeleteModal = (id) => {
    setItemToDelete(id);
    setShowDeleteModal(true);
  };
  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setItemToDelete(null);
  };
  const handleAddClose = () => {
    setAddShow(false);
    setRecordForEdit(null);
  };
  const handleAddShow = () => {
    setRecordForEdit(null); // Clear any previous edit
    setValues(initialFieldValues); // Reset form
    setAddShow(true);
  };
  useEffect(() => {
    if (recordForEdit !== null) {
      setValues(recordForEdit);
    }
  }, [recordForEdit]);
  const GetData = async (pageNumber) => {
    const res = await apiService.get(
      `${config.GETCOMPANYAGENTS}/${user?.cid}`,
      pageSize,
      pageNumber
    );
    setLists(res.data);
    setPageNumber(res.pageNumber);
    setPageSize(res.pageSize);
    setTotalPages(res.totalPages);
    setData(res.data);
    setTotalRecords(res.totalRecords);
  };
  const GetLastPageData = () => {
    GetData(totalPages);
  };
  const GetFirstPageData = () => {
    GetData("1");
  };
  const GetPageData = (number) => {
    setPageNumber(number);
    if (pageNumber !== number) GetData(number);
  };
  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }
  const renderPageNumbers = pageNumbers.map((number) => {
    return (
      <li
        className="page-item"
        key={number}
        id={number}
        onClick={() => GetPageData(number)}
      >
        <Link className="page-link">{number}</Link>
      </li>
    );
  });
  const showEditDetails = (data) => {
    setRecordForEdit(data);
    setValues(data);
    setAddShow(true);
  };
  const handleDelete = async () => {
    if (itemToDelete !== null) {
      try {
        await apiService.remove(config.DELETECOMPANY, itemToDelete);
        await GetData(pageNumber);
      } catch (error) {
        // Error toast already handled by apiService
        // Optionally log or track error here
      }
      handleCloseDeleteModal();
    }
  };
  const validate = () => {
    let temp = {};
    temp.companyName = values.companyName === "" ? false : true;
    temp.email = values.email === "" ? false : true;
    temp.phoneNumber = values.phoneNumber === "" ? false : true;
    setErrors(temp);
    return Object.values(temp).every((x) => x === true);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      setBtnLoading(true);
      const formData = new FormData();
      formData.append("companyId", values.companyId);
      formData.append("companyName", values.companyName);
      formData.append("brandName", values.brandName);
      formData.append("email", values.email);
      formData.append("phoneNumber", values.phoneNumber);
      formData.append("gstNo", values.gstNo);
      formData.append("panCard", values.panCard);
      formData.append("address", values.address);
      formData.append("city", values.city);
      formData.append("state", values.state);
      formData.append("country", values.country);
      formData.append("currency", values.currency);
      formData.append("isActive", values.isActive);
      formData.append("parentCompanyId", user?.cid);
      formData.append("logoFile", null);
      try {
        const isNew =
          formData.companyId === "00000000-0000-0000-0000-000000000000";

        if (isNew) {
          await apiService.create(config.CREATECOMPANY, formData);
        } else {
          await apiService.update(config.UPDATECOMPANY, formData);
        }
        await GetData(pageNumber);
        resetForm();
      } finally {
        setBtnLoading(false); // ensure loading button resets even on error
      }
    }
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const fieldsToUppercase = [
      "companyName",
      "brandName",
      "gstNo",
      "city",
      "state",
    ];
    setValues({
      ...values,
      [name]: fieldsToUppercase.includes(name) ? value.toUpperCase() : value,
    });
  };
  const resetForm = () => {
    setValues(initialFieldValues);
    setAddShow(false);
    setBtnLoading(false);
  };
  const applyErrorClass = (field) =>
    field in errors && errors[field] === false ? " form-control-danger" : "";
  useEffect(() => {
    if (user && !loading) {
      GetData(pageNumber);
    }
  }, [user, loading]);
  if (loading) return <p>Loading...</p>;
  if (!user) {
    navigate("/");
  }
  return (
    <div id="layout-wrapper">
      <Header User={user} />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="col-xl-12">
              <div className="card">
                <div className="p-2">
                  <AgentTabs pageName="CREDIT" />
                </div>
                <div className="me-2 pb-1">
                  <div className="row g-4 align-items-center">
                    <div className="col-sm-auto ms-auto">
                      <div className="hstack gap-2">
                        <button
                          type="button"
                          className="btn btn-primary add-btn"
                          onClick={handleAddShow}
                        >
                          <i className="ri-add-line align-bottom me-1" /> Add
                          Credit
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  <div className="table-responsive table-card p-2">
                    <table className="table align-middle" id="customerTable">
                      <thead className="bg-soft-success bg-gradient">
                        <tr>
                          <th>Id</th>
                          <th>Company</th>
                          <th>Brand</th>
                          <th>Email</th>
                          <th>Phone</th>
                          <th>Location</th>
                          <th>Currency</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody className="list form-check-all">
                        {lists.length > 0 &&
                          lists.map((v, index) => (
                            <tr key={v.companyId}>
                              <td>{index + 1}</td>
                              <td>{v.companyName}</td>
                              <td>{v.brandName}</td>
                              <td>{v.email}</td>
                              <td>{v.phoneNumber}</td>
                              <td>
                                {v.city}, {v.country}
                              </td>
                              <td>{v.currency}</td>
                              <td>
                                {v.isActive === true ? (
                                  <span className="badge bg-success">
                                    ACTIVE
                                  </span>
                                ) : (
                                  <span className="badge bg-danger">
                                    IN-ACTIVE
                                  </span>
                                )}
                              </td>
                              <td>
                                <ul className="list-inline hstack gap-2 mb-0">
                                  <li
                                    className="list-inline-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-trigger="hover"
                                    data-bs-placement="top"
                                    title="Edit"
                                  >
                                    <Link
                                      className="edit-item-btn"
                                      onClick={(e) => showEditDetails(v)}
                                    >
                                      <i className="ri-pencil-fill align-bottom text-muted" />
                                    </Link>
                                  </li>
                                  <li
                                    className="list-inline-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-trigger="hover"
                                    data-bs-placement="top"
                                    title="Delete"
                                  >
                                    <Link
                                      className="remove-item-btn"
                                      onClick={(e) =>
                                        handleOpenDeleteModal(v.companyId)
                                      }
                                    >
                                      <i className="ri-delete-bin-fill align-bottom text-muted" />
                                    </Link>
                                  </li>
                                </ul>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="align-items-center mt-4 pt-2 justify-content-between d-flex">
                    <div className="flex-shrink-0">
                      <div className="text-muted">
                        Showing{" "}
                        <span className="fw-semibold">{lists.length}</span> of{" "}
                        <span className="fw-semibold">{totalRecords}</span>{" "}
                        Results
                      </div>
                    </div>
                    <ul className="pagination pagination-separated pagination-sm mb-0">
                      <li
                        className={
                          "page-item" + data.previousPage === null
                            ? "disabled"
                            : ""
                        }
                        onClick={() => GetFirstPageData()}
                      >
                        <Link className="page-link">Previous</Link>
                      </li>
                      {renderPageNumbers}
                      <li
                        className={
                          "page-item" + data.nextPage === null ? "disabled" : ""
                        }
                        onClick={() => GetLastPageData()}
                      >
                        <Link className="page-link">Next</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal show={addShow} onHide={handleAddClose} size="lg">
          <Modal.Header>
            <Modal.Title>
              {values.companyId === "00000000-0000-0000-0000-000000000000"
                ? "Add"
                : "Edit"}{" "}
              Company
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={handleSubmit} autoComplete="off" noValidate>
              <div className="row">
                <div className="col-lg-4 mb-3">
                  <label htmlFor="companyName" className="form-label">
                    Company Name
                  </label>
                  <input
                    type="text"
                    max={45}
                    value={values.companyName}
                    name="companyName"
                    onChange={handleInputChange}
                    className={"form-control" + applyErrorClass("companyName")}
                    placeholder="Please Enter Company Name"
                  />
                  {errors.companyName === false ? (
                    <div className="validationerror">Please enter name </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-lg-4 mb-3">
                  <label htmlFor="brandName" className="form-label">
                    Brand Name
                  </label>
                  <input
                    type="text"
                    max={45}
                    value={values.brandName}
                    name="brandName"
                    onChange={handleInputChange}
                    className={"form-control" + applyErrorClass("brandName")}
                    placeholder="Please Enter Brand Name"
                  />
                  {errors.brandName === false ? (
                    <div className="validationerror">
                      Please enter brand name{" "}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-lg-4 mb-3">
                  <label htmlFor="email" className="form-label">
                    Email
                  </label>
                  <input
                    type="text"
                    max={45}
                    value={values.email}
                    name="email"
                    onChange={handleInputChange}
                    className={"form-control" + applyErrorClass("email")}
                    placeholder="Please enter email"
                  />
                  {errors.email === false ? (
                    <div className="validationerror">Please enter email </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-lg-4 mb-3">
                  <label htmlFor="mobile" className="form-label">
                    Phone Number
                  </label>
                  <input
                    type="text"
                    max={15}
                    value={values.phoneNumber}
                    name="phoneNumber"
                    onChange={handleInputChange}
                    className={"form-control" + applyErrorClass("phoneNumber")}
                    placeholder="Please enter phone"
                  />
                  {errors.phoneNumber === false ? (
                    <div className="validationerror">
                      Please enter phone number{" "}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-lg-4 mb-3">
                  <label htmlFor="gstNo" className="form-label">
                    GST Number
                  </label>
                  <input
                    type="text"
                    max={15}
                    value={values.gstNo}
                    name="gstNo"
                    onChange={handleInputChange}
                    className={"form-control" + applyErrorClass("gstNo")}
                    placeholder="Please enter gst no"
                  />
                  {errors.gstNo === false ? (
                    <div className="validationerror">
                      Please enter gst number{" "}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-lg-4 mb-3">
                  <label htmlFor="city" className="form-label">
                    City
                  </label>
                  <input
                    type="text"
                    max={45}
                    value={values.city}
                    name="city"
                    onChange={handleInputChange}
                    className={"form-control" + applyErrorClass("city")}
                    placeholder="City"
                  />
                  {errors.city === false ? (
                    <div className="validationerror">Please enter city </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-lg-4 mb-3">
                  <label htmlFor="state" className="form-label">
                    State
                  </label>
                  <input
                    type="text"
                    max={45}
                    value={values.state}
                    name="state"
                    onChange={handleInputChange}
                    className={"form-control" + applyErrorClass("state")}
                    placeholder="State"
                  />
                  {errors.state === false ? (
                    <div className="validationerror">Please enter state </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-lg-4 mb-3">
                  <label htmlFor="tcs" className="form-label">
                    Country
                  </label>
                  <select
                    className="form-select"
                    value={values.country}
                    name="country"
                    onChange={handleInputChange}
                  >
                    {countries.length > 0 &&
                      countries.map((cs) => (
                        <option value={cs.name}>
                          {cs.name} - {cs.code}
                        </option>
                      ))}
                  </select>
                  {errors.country === false ? (
                    <div className="validationerror">
                      Please select country{" "}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-lg-4 mb-3">
                  <label htmlFor="currency" className="form-label">
                    Currency
                  </label>
                  <select
                    className="form-select"
                    value={values.currency}
                    name="currency"
                    onChange={handleInputChange}
                  >
                    {currencies.length > 0 &&
                      currencies.map((cs) => (
                        <option value={cs.code}>
                          {cs.name} - {cs.code}
                        </option>
                      ))}
                  </select>
                  {errors.currency === false ? (
                    <div className="validationerror">
                      Please select currency{" "}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-lg-4 mb-3">
                  <label htmlFor="isActive" className="form-label">
                    STATUS
                  </label>
                  <select
                    name="isActive"
                    value={values.isActive}
                    onChange={handleInputChange}
                    className={"form-select" + applyErrorClass("isActive")}
                  >
                    <option value={true}>ACTIVE</option>
                    <option value={false}>IN-ACTIVE</option>
                  </select>
                </div>
                <div className="col-lg-8 mb-3">
                  <label htmlFor="address" className="form-label">
                    Address
                  </label>
                  <input
                    type="text"
                    max={200}
                    value={values.address}
                    name="address"
                    onChange={handleInputChange}
                    className={"form-control" + applyErrorClass("address")}
                    placeholder="Address"
                  />
                  {errors.address === false ? (
                    <div className="validationerror">Please enter address </div>
                  ) : (
                    ""
                  )}
                </div>
                <Modal.Footer>
                  <div className="hstack gap-2 justify-content-end mb-3 mt-4">
                    {btnLoading === false ? (
                      <button type="submit" className="btn btn-primary">
                        {values.companyId ===
                        "00000000-0000-0000-0000-000000000000"
                          ? "Submit"
                          : "Update"}
                      </button>
                    ) : (
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled
                      >
                        Please wait...
                      </button>
                    )}
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={resetForm}
                    >
                      Cancel
                    </button>
                  </div>
                </Modal.Footer>
              </div>
            </form>
          </Modal.Body>
        </Modal>
        <DeleteAlert
          show={showDeleteModal}
          handleClose={handleCloseDeleteModal}
          handleDelete={handleDelete}
        />
      </div>
    </div>
  );
};

export default AgentCredits;
